import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Tooltip } from 'antd';
import { Zap } from 'lucide-react';
import { togglePerformance } from '../../redux/slices/performanceSlice';

const PerformanceToggle = () => {
    const dispatch = useDispatch();
    const highPerformance = useSelector((state) => state.performance.highPerformance);

    return (
        <Tooltip title={highPerformance ? 'Tắt hiệu ứng' : 'Bật hiệu ứng'}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: '16px' }}>
                <Zap size={16} color={highPerformance ? '#FFD700' : '#888'} style={{ marginRight: '6px' }} />
                <Switch size="small" checked={highPerformance} onChange={() => dispatch(togglePerformance())} />
            </div>
        </Tooltip>
    );
};

export default PerformanceToggle;
